import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBPpqZHOHPHZBCLyXz0YZBPzBHvPD-Hs_Y",
  authDomain: "kismetagent.firebaseapp.com",
  projectId: "kismetagent",
  storageBucket: "kismetagent.appspot.com",
  messagingSenderId: "1098480001796",
  appId: "1:1098480001796:web:d2c8d3d0c90e6b2e3e0e3e",
  measurementId: "G-MEASUREMENT_ID"
};

// Initialiser Firebase
const app = initializeApp(firebaseConfig);

// Initialiser Firestore
export const db = getFirestore(app); 